<template>
  <div id="getRewardedLockModal" class="modal fade modal-flex" tabindex="-1" role="dialog">
    <div class="modal-dialog modal-sm" role="document">
      <div class="modal-content reward-modal reward-modal-small">
        <div class="modal-body">
          <h4 class="title">{{ $t('claim_success') }}</h4>
          <img src="/themes/ito/images/key-reward.svg" alt="">
          <div class="gem">
            <span id="congratulation_gem">+{{reward}}</span>
          </div>


          <!-- <img src="/themes/ito/images/get-rewarded.svg" alt="">

          <div class="gem">
            <span id="congratulation_lock">0</span> <i class="ito-icon-lock"></i>
          </div> -->

          <button class="btn btn-ito-2-large" data-bs-dismiss="modal"
                  aria-label="Close">
            OK
          </button>
        </div>

        <i class="ito-icon-close modal-close" data-bs-dismiss="modal"
           aria-label="Close"></i>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GetRewardLockModal",
  props: ['reward'],
}
</script>

<style scoped>

</style>
